import type { GQL_ID } from '@@partner:types:graphql'
import type { Promocode } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PROMOCODE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SinglePromocodeQuery {
  promocode: Promocode
}
export interface SinglePromocodeQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_PROMOCODE = gql`
  query (
    $id: ID!
  ) {
    promocode: singlePromocode(id: $id) {
      ${SHORTCUT_PROMOCODE_FIELDS}
    }
  }
`

export const useFetchSinglePromocode = (
  variables: SinglePromocodeQueryVariables
) =>
  useQuery<SinglePromocodeQuery, SinglePromocodeQueryVariables>(
    GQL_QUERY_SINGLE_PROMOCODE,
    {
      variables,
      skip: !variables.id
    }
  )
